// src/utils/tokenUtils.js
import { TOKEN_KEY, ADMIN_TOKEN_KEY, USER_KEY, ADMIN_USER_KEY } from '../constants/storageKeys';

/**
 * Clear all authentication tokens and user data from storage
 */
export const clearAllAuthTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
};

/**
 * Check if there's a regular user token
 */
export const hasUserToken = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

/**
 * Check if there's an admin token
 */
export const hasAdminToken = () => {
  return !!localStorage.getItem(ADMIN_TOKEN_KEY);
};

/**
 * Get the stored user data
 */
export const getStoredUser = () => {
  const userData = localStorage.getItem(USER_KEY);
  if (userData) {
    try {
      return JSON.parse(userData);
    } catch (e) {
      console.error('Failed to parse stored user data', e);
      return null;
    }
  }
  return null;
};

/**
 * Get the stored admin user data
 */
export const getStoredAdminUser = () => {
  const adminUserData = localStorage.getItem(ADMIN_USER_KEY);
  if (adminUserData) {
    try {
      return JSON.parse(adminUserData);
    } catch (e) {
      console.error('Failed to parse stored admin user data', e);
      return null;
    }
  }
  return null;
};

/**
 * Store user data
 */
export const storeUserData = (user) => {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
};

/**
 * Store admin user data
 */
export const storeAdminUserData = (adminUser) => {
  if (adminUser) {
    localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(adminUser));
  }
};